import './PurchaseTask.css';

const PurchaseTask = ({ task }) => {
  return (
    <div className="purchase-task">
      <p>
        Buy{' '}
        {task.banana} Banana{task.banana > 1 ? '’s' : ''} and{' '}
        {task.orange} Orange{task.orange > 1 ? 's' : ''}
        {/* Add more fruits similarly if needed */}
      </p>
    </div>
  );
};


const fruitEmoji = {
  banana: '🍌',
  orange: '🍊',
  strawberry: '🍓',
  apple: '🍎',
};

const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

export default PurchaseTask;
